import React from 'react';
import { styled } from '@linaria/react';

const ImageElement = styled.img<StyledProps>`
  width: ${(props) => (props.width ? props.width + 'px' : 'auto')};
  svg {
    fill: black;
  }

  &.close-red {
    width: 12px;
    position: relative;
    left: -2px;
    top: 0px;
  }
`;
interface StyledProps {
  width?: number;
}

export interface IconProps {
  id?: string | undefined;
  className?: string | undefined;
  theme?: any;
  name: string;
  width?: number;
}

function importAllIcons(assets: __WebpackModuleApi.RequireContext) {
  const imageSet: Record<string, string> = {};

  assets.keys().map((image) => {
    imageSet[image.replace("./", "")] = assets(image);
  });
  return imageSet;
}

function Icon({ name, width, className, id }: IconProps) {
  // @ts-ignore
  const icons = importAllIcons(    require.context("@assets/icon/", false, /\.(svg)$/));
  return (
    <ImageElement id={id} className={className} src={icons[`${name}.svg`]} width={width} />
  );
}

Icon.defaultProps = {
  name: 'download',
};

export default Icon;
